import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class NVMilestoneBusinessLaneApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'nv-milestone-business-lane'
    }

}